import { useContext } from 'react';
import AuthenticationContext from './authentication.context';

export interface RoleHookResponse {
  isBeheerder: boolean;
}

export const useRoleHook = (): RoleHookResponse => {
  const { rollen } = useContext(AuthenticationContext);
  return {
    isBeheerder: rollen.some((rol) => rol.toLowerCase() === 'beheerder'),
  };
};
